import React, { useMemo } from 'react';
import SearchableSelect from './SearchableSelect';

/**
 * Select commercial unifié hors barre de filtres (formulaires).
 * Même UX que le chiffrage / AppFilterCommercialSelect : searchable, mono, vidable, « — ».
 *
 * Accepte soit `options` [{ value, label }], soit `commerciaux` [{ id, nom }].
 * value: string|number|null ; onChange: (next: string) => void  ('' si vide)
 */
export default function CommercialSelect({
  id,
  value = '',
  onChange,
  options,
  commerciaux = [],
  disabled = false,
  required = false,
  className = '',
  buttonClassName = 'form-select text-start',
  placeholder = '—',
  emptyLabel = 'Aucun commercial',
  allowEmpty = true,
}) {
  const resolvedOptions = useMemo(() => {
    if (Array.isArray(options) && options.length) {
      return options;
    }
    return (commerciaux ?? []).map((c) => ({
      value: String(c.id),
      label: c.nom,
    }));
  }, [options, commerciaux]);

  return (
    <SearchableSelect
      id={id}
      value={value != null && value !== '' ? String(value) : ''}
      onChange={onChange}
      options={resolvedOptions}
      placeholder={placeholder}
      emptyLabel={emptyLabel}
      allowEmpty={allowEmpty}
      emptyOptionLabel="—"
      disabled={disabled}
      required={required}
      className={className}
      buttonClassName={buttonClassName}
    />
  );
}
